import {
    suite0,
    suite1,
    suite10,
    suite2,
    suite3,
    suite4,
    suite5,
    suite6,
    suite7,
    suite8,
    suite9,
} from "@/assets/images";
import { useGetCommon, type AttractionResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Spinner } from "@chakra-ui/react";
import { Carousel } from "react-responsive-carousel";
import { CustomBox, CustomText, CustomTitle } from "./attractions.style";

export const Attractions = () => {
    const { data } = useGetCommon<AttractionResponse>({ section: "travels" });
    const { isMobile } = MEDIA();
    const { idx } = getDefaultParameters();
    const suiteianImgList = [
        {
            imgUrl: suite0,
        },
        {
            imgUrl: suite1,
        },
        {
            imgUrl: suite2,
        },
        {
            imgUrl: suite3,
        },
        {
            imgUrl: suite4,
        },
        {
            imgUrl: suite5,
        },
        {
            imgUrl: suite6,
        },
        {
            imgUrl: suite7,
        },
        {
            imgUrl: suite8,
        },
        {
            imgUrl: suite9,
        },
        {
            imgUrl: suite10,
        },
    ];
    return data ? (
        <CustomBox as="section">
            <Center flexDir="column" mb="64px">
                <CustomTitle as="h3">ENJOY TRVEL</CustomTitle>
                <CustomText>{data.pensionInfo.name.kr} 주변 관광지 미리보기</CustomText>
            </Center>
            <Carousel
                showStatus={false}
                showThumbs={false}
                showArrows={false}
                emulateTouch
                showIndicators
                infiniteLoop
                autoPlay
                interval={3000}
                preventMovementUntilSwipeScrollTolerance
                swipeScrollTolerance={100}
            >
                {idx === "2017"
                    ? suiteianImgList.map((img) => (
                          <Box
                              key={img.imgUrl}
                              w="100%"
                              h={isMobile ? "320px" : "480px"}
                              background={`url(${img.imgUrl}) no-repeat center/contain`}
                          ></Box>
                      ))
                    : data.imgList.map((img) => (
                          <Box
                              key={img.imgUrl}
                              w="100%"
                              h={isMobile ? "320px" : "480px"}
                              background={`url(${img.imgUrl}) no-repeat center/cover`}
                          ></Box>
                      ))}
            </Carousel>
        </CustomBox>
    ) : (
        <Spinner />
    );
};
